import { render, staticRenderFns } from "./BLTUpload.vue?vue&type=template&id=65ecd34a&scoped=true&"
import script from "./BLTUpload.vue?vue&type=script&lang=js&"
export * from "./BLTUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ecd34a",
  null
  
)

export default component.exports